module.exports = __webpack_public_path__ + "static/media/clock.498685a2.svg";